import React from 'react';
import { Input, Textarea, Select, Button, PaperClip, DatePicker, Tooltip } from 'components';
import moment from 'moment';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { AlertIcon, UploadIcon, DownloadIcon, TrashIcon } from 'assets/icons';
import { RouteComponentProps } from 'react-router-dom';
import { DocumentService } from 'services';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Documents extends React.Component<Props> {

	state = {
		form: {
			file: ''
		},
		information_file: null
	}

	componentDidMount() {
		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await DocumentService.get({
			withoutLoading
		});
		this.setState({
			information_file: res.information_file
		});
	}

	submit = async () => {
		const res: any = await DocumentService.save({
			// @ts-ignore
			file: this.state.form.file?.value,
			hasFile: true,
			user_id: this.props.user?.id
		});
		Globals.showSuccess("Se ha guardado el documento correctamente");
		if (res?.information_file) {
			this.setState({
				information_file: res.information_file
			});
		}
	}

	download = (e: any) => {
		e.preventDefault();
		Globals.confirm('¿Eliminar el archivo?',async () => {
			await DocumentService.delete();
			this.load(true);
		});
	}

	render() {
		return (
			<div id="client-documents">
				<div className="form-blue">
					<div className="container-title">
						<img src={ AlertIcon } />
						<p>Sube un documento con toda la información detallada de tu negocio</p>
					</div>
					<div className="container-title upper">
						<img src={ UploadIcon } />
						<p>Subir documento</p>
					</div>
					<h6>Se admite un documento</h6>
					<div className="text-center">
						{
							this.state.information_file != null ? (
								<div className="information-file">
									<p>Archivo Cargado</p>
									<Tooltip title="Descargar">
										{/*
										// @ts-ignore */}
										<a target="_blank" href={ Constants.BASE_STORAGE + this.state.information_file?.file }>
											<img src={ DownloadIcon } />
										</a>
									</Tooltip>
									<Tooltip title="Eliminar">
										<a href="#" onClick={ this.download }>
											<img src={ TrashIcon } />
										</a>
									</Tooltip>
								</div>
							) : (
								<PaperClip
									formats={['xlsx','xls','pdf','doc','docx']}
									onChange={ (e: any) => {
										this.setState({
											form: {
												...this.state.form,
												file: e.target
											}
										},() => this.submit());
									} }>
									<div className="btn-upload">
										Seleccionar documento
									</div>
								</PaperClip>
							)
						}
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Documents);